import React, { useEffect, useState } from "react";
import { FaBook, FaClock } from "react-icons/fa";

function WordCountReadingTime({ quill }) {
  const [wordCount, setWordCount] = useState(0);
  const [readingTime, setReadingTime] = useState(0);
  const [characterCount, setCharacterCount] = useState(0);

  useEffect(() => {
    if (!quill) return;

    const updateStats = () => {
      const text = quill.getText();
      const words = text.trim().split(/\s+/).filter(word => word.length > 0);
      const characters = text.length;

      setWordCount(words.length);
      setCharacterCount(characters);

      // Assuming average reading speed of 200 words per minute
      const minutes = Math.ceil(words.length / 200);
      setReadingTime(minutes);
    };

    updateStats();
    quill.on("text-change", updateStats);

    return () => {
      quill.off("text-change", updateStats);
    };
  }, [quill]);

  return (
    <div className="bg-white border border-gray-200 rounded-md shadow-sm">
      <div className="px-3 py-2 border-b border-gray-200 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-700">Document Statistics</h3>
      </div>
      <div className="px-3 py-2 flex flex-col space-y-1">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600 flex items-center">
            <FaBook className="mr-2 text-gray-400" /> Words
          </span>
          <span className="font-medium">{wordCount.toLocaleString()}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Characters</span>
          <span className="font-medium">{characterCount.toLocaleString()}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600 flex items-center">
            <FaClock className="mr-2 text-gray-400" /> Reading Time
          </span>
          <span className="font-medium">
            {readingTime < 1 ? "< 1 min" : `${readingTime} min${readingTime !== 1 ? "s" : ""}`}
          </span>
        </div>
      </div>
    </div>
  );
}

export default WordCountReadingTime;